import React from 'react';
import { withRouter } from 'react-router-dom';
import CadastrarMovimentacaoForm from './CadastrarMovimentacaoForm.jsx';
import CadastrarMovimentacaoConf from './CadastrarMovimentacaoConf.jsx';

class CadastrarMovimentacao extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            centroId: 0,
            centro: "",
            contas: [],
            conta: "",
            codigoConta: "",
            codigo: "",
            bancos: [],
            banco: "",
            historico: "",
            descricao: "",
            data: "",
            valor: "0,00",
            ghg: false,
            notaFiscal: null,
            comprovante: null,
            analiseContabil: "",
            conf: false,
            filtroAno: "",
            filtroMes: ""
        };

        this.changeData = this.changeData.bind(this);
        this.changeBanco = this.changeBanco.bind(this);
        this.changeConta = this.changeConta.bind(this);
        this.changeHistorico = this.changeHistorico.bind(this);
        this.changeDescricao = this.changeDescricao.bind(this);
        this.changeValor = this.changeValor.bind(this);
        this.changeGhg = this.changeGhg.bind(this);
        this.changeNotaFiscal = this.changeNotaFiscal.bind(this);
        this.changeNotaFiscal = this.changeNotaFiscal.bind(this);
        this.changeComprovante = this.changeComprovante.bind(this);
        this.changeAnaliseContabil = this.changeAnaliseContabil.bind(this);
        this.cadastrar = this.cadastrar.bind(this);
        this.cancelar = this.cancelar.bind(this);
        this.voltar = this.voltar.bind(this);
        this.confirmar = this.confirmar.bind(this);

    }

    moneyMask(str_val) {

        let res = ""; 
        let vec = str_val.split(".");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }   

            c++;

        }   

        if (vec[1] !== undefined) res = res + "," + vec[1];
        else res = res + ",00";

        return res;

    }

    moneyUnmask(str_val) {

        let res = ""; 
        let vec = str_val.split(",");

        for (let i = 0; i < vec[0].length; i++) {

            if (vec[0][i] !== ".") {
                res = res + vec[0][i];
            }

        }

        res = res + "." + vec[1];
        return res;

    }

    desformatarValor(s) {
        if (s === null) return "";
        return this.moneyUnmask(s);
    }

    formatarValor(s) {
        if (s === null) return "";
        return this.moneyMask(s);
    }

    changeData(e) {

        let i = e.target.value;

        if (i !== "" && this.state.conta !== "") {

            let vec = i.split("-");
            this.setState({ data: i });
            this.setState({ codigo: this.state.codigoConta + "-" + vec[1] });

        } else if (i !== "" && this.state.conta === "") {

            this.setState({ data: i });
            this.setState({ codigo: "" });

        } else {

            this.setState({ data: i });
            this.setState({ codigo: "" });

        }

    }

    changeBanco(e) {
        this.setState({ banco: e.target.value });
    }

    changeConta(e) {

        let i = e.target.value;

        if (i !== "" && this.state.data !== "") {

            let vec = this.state.data.split("-");
            this.setState({ conta: i });
            this.setState({ codigoConta: this.state.contas[i].cod_conta });
            this.setState({ codigo: this.state.contas[i].cod_conta + "-" + vec[1] });

        } else if (i !== "" && this.state.data === "") {

            this.setState({ conta: i });
            this.setState({ codigoConta: this.state.contas[i].cod_conta });
            this.setState({ codigo: "" });

        } else {

            this.setState({ conta: "" });
            this.setState({ codigoConta: "" });
            this.setState({ codigo: "" });

        }

    }

    changeHistorico(e) {
        this.setState({ historico: e.target.value });
    }

    changeDescricao(e) {
        this.setState({ descricao: e.target.value });
    }

    changeValor(e) {

        let sval = ""; 
        let re = /^(-|[0-9])$/i;
        let neg = false;

        if (e.target.value !== "-0,0") {

            for (let i = 0; i < e.target.value.length; i++) {

                if (re.test(e.target.value[i])) {

                    if (e.target.value[i] === "-") neg = true;
                    else sval = sval + e.target.value[i];

                }

            }

        }

        sval = parseInt(sval);
        sval = sval.toString();
        let res = "";

        if (sval === "NaN") {

            res = "0,00";

        } else if (sval.length === 1) {

            res = "0,0" + sval;

        } else if (sval.length === 2) {

            res = "0," + sval;

        } else {

            let i = sval.length - 1;
            let c = 0;

            res = sval[i] + res;
            i--;

            res = sval[i] + res;
            i--;

            res = "," + res;

            for (; i >= 0; i--) {

                if (c !== 0 && c % 3 === 0) {
                    res = sval[i] + "." + res;
                } else {
                    res = sval[i] + res;
                }

                c++;

            }

        }

        if (neg) {
            res = "-" + res;
        }

        this.setState({ valor: res });

    }

    changeGhg(e) {
        if (e.target.value === "true") this.setState({ ghg: true });
        else this.setState({ ghg: false });
    }

    changeNotaFiscal(e) {
        e.preventDefault();
        this.setState({ notaFiscal: e.target.files[0] });
    }

    changeComprovante(e) {
        e.preventDefault();
        this.setState({ comprovante: e.target.files[0] });
    }

    changeAnaliseContabil(e) {
        this.setState({ analiseContabil: e.target.value });
    }

    cadastrar() {

        let re = /^.{1,}\.(pdf|xml|jpg|jpeg|png)$/i;

        if (this.state.data === "") {

            this.props.errMsgHandler("Por favor, informe a data da movimentação financeira.");

        } else if (this.state.banco === "") {

            this.props.errMsgHandler("Por favor, informe o banco.");

        } else if (this.state.conta === "") {

            this.props.errMsgHandler("Por favor, informe a conta da movimentação financeira.");

        } else if (this.state.historico === "") {

            this.props.errMsgHandler("Por favor, informe o histórico.");

        } else if (this.state.descricao === "") {

            this.props.errMsgHandler("Por favor, informe a descrição da movimentação financeira.");

        } else if (this.state.valor === "0,00" || this.state.valor === "-0,00") {

            this.props.errMsgHandler("Por favor, informe o valor da movimentação financeira.");

        } else if (this.state.notaFiscal === null) {

            this.props.errMsgHandler("Por favor, faça o anexo do documento fiscal.");

        } else if (!re.test(this.state.notaFiscal.name)) {

            this.props.errMsgHandler("É permitido somente o anexo de arquivos PDF, XML, JPG e PNG.");

        } else if (this.state.comprovante === null) {

            this.props.errMsgHandler("Por favor, faça o anexo do comprovante de pagamento.");

        } else if (!re.test(this.state.comprovante.name)) {

            this.props.errMsgHandler("É permitido somente o anexo de arquivos PDF, XML, JPG e PNG.");

        } else if (this.state.analiseContabil === "") {

            this.props.errMsgHandler("Por favor, informe a análise contábil.");

        } else {

            this.props.errMsgHandler("");
            this.setState({ conf: true });

        }

    }

    cancelar() {

        let obj = {
            row: {
                id: this.state.centroId,
                data: [ this.state.centro ],
                filtroAno: this.state.filtroAno,
                filtroMes: this.state.filtroMes
            }
        };

        this.props.history.push({
            pathname: "/movimentacoescentro",
            state: obj
        });

    }

    voltar() {
        this.setState({ conf: false });
    }

    confirmar() {

        this.setState({ disabled: true });
        this.props.waitMsgHandler("Aguardando");

        let obj = {
            banco: this.state.banco,
            data: this.state.data,
            historico: this.state.historico,
            descricao: this.state.descricao,
            valor: this.desformatarValor(this.state.valor),
            ghg: this.state.ghg,
            status: 0,
            nota_fiscal: this.state.notaFiscal.name,
            comprovante: this.state.comprovante.name,
            analise_contabil: this.state.analiseContabil,
            conta_id: this.state.contas[this.state.conta].id,
            cadastrado_por: JSON.parse(localStorage.usuarioInfo).id
        };

        let formData1 = new FormData();
        formData1.append('file', this.state.notaFiscal);

        let formData2 = new FormData();
        formData2.append('file', this.state.comprovante);

        fetch("/api/movimentacao/", {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors",
            body: JSON.stringify(obj)
        })
        .then(response => response.json())
        .then(responseJson => {

            if (responseJson.msg === "success") {

                fetch("/api/movimentacao/upload/nf/" + responseJson.id, {
                    method: "POST",
                    headers: {
                        "Authorization": "Basic " + btoa(localStorage.auth)
                    },
                    mode: "cors",
                    body: formData1
                })
                .then(response2 => response2.json())
                .then(responseJson2 => {

                    if (responseJson2.msg === "success") {

                        fetch("/api/movimentacao/upload/cp/" + responseJson.id, {
                            method: "POST",
                            headers: {
                                "Authorization": "Basic " + btoa(localStorage.auth)
                            },
                            mode: "cors",
                            body: formData2
                        })
                        .then(response3 => response3.json())
                        .then(responseJson3 => {

                            if (responseJson3.msg === "success") {

                                this.props.waitMsgHandler("");
                                this.props.successMsgHandler("Movimentação financeira cadastrada com sucesso.");

                                let obj = {
                                    row: {
                                        id: this.state.centroId,
                                        data: [ this.state.centro ],
                                        filtroAno: this.state.filtroAno,
                                        filtroMes: this.state.filtroMes
                                    }
                                };

                                this.props.history.push({
                                    pathname: "/movimentacoescentro",
                                    state: obj
                                });

                            }

                        });

                    }

                });

            }

        });

    }

    componentDidMount() {

        if (localStorage.roleMovimentacoes !== "escrever"
            && localStorage.roleMovimentacoes !== "corrigir") {

            window.location.href = "/home";

        }

        if (this.props.location.state === undefined) {
            window.location.href = "/movimentacoescentro";
        }

        let centroId = this.props.location.state.centroId;
        let centro = this.props.location.state.centro;
        let filtroAno = this.props.location.state.filtroAno;
        let filtroMes = this.props.location.state.filtroMes;

        this.setState({ centroId: centroId });
        this.setState({ centro: centro });
        this.setState({ filtroAno: filtroAno });
        this.setState({ filtroMes: filtroMes });

        fetch("/api/centro/banco/" + centroId, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ bancos: responseJson });

            fetch("/api/conta/centro/" + centroId, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response2 => response2.json())
            .then(responseJson2 => {

                this.setState({ contas: responseJson2 });

            });

        });

    }

    render() {
        return(
            <div>
                <h1 id="cadmovimentacao-title">Cadastrar Movimentação Financeira</h1><br />
                <p id="cadmovimentacao-centro">
                    <b>Centro:</b> { this.state.centro }
                </p><br />
                { this.state.conf === false &&
                    <CadastrarMovimentacaoForm
                        data={ this.state.data }
                        changeData={ this.changeData }
                        bancos={ this.state.bancos }
                        banco={ this.state.banco }
                        changeBanco={ this.changeBanco }
                        contas={ this.state.contas }
                        conta={ this.state.conta }
                        changeConta={ this.changeConta }
                        codigoConta={ this.state.codigoConta }
                        codigo={ this.state.codigo }
                        historico={ this.state.historico }
                        changeHistorico={ this.changeHistorico }
                        descricao={ this.state.descricao }
                        changeDescricao={ this.changeDescricao }
                        valor={ this.state.valor }
                        changeValor={ this.changeValor }
                        ghg={ this.state.ghg }
                        changeGhg={ this.changeGhg }
                        notaFiscal={ this.state.notaFiscal }
                        changeNotaFiscal={ this.changeNotaFiscal }
                        comprovante={ this.state.comprovante }
                        changeComprovante={ this.changeComprovante }
                        analiseContabil={ this.state.analiseContabil }
                        changeAnaliseContabil={ this.changeAnaliseContabil }
                        cadastrar={ this.cadastrar }
                        cancelar={ this.cancelar } /> }
                { this.state.conf === true &&
                    <CadastrarMovimentacaoConf
                        data={ this.state.data }
                        bancos={ this.state.bancos }
                        banco={ this.state.banco }
                        contas={ this.state.contas }
                        conta={ this.state.conta }
                        codigoConta={ this.state.codigoConta }
                        codigo={ this.state.codigo }
                        historico={ this.state.historico }
                        descricao={ this.state.descricao }
                        valor={ this.state.valor }
                        ghg={ this.state.ghg }
                        notaFiscal={ this.state.notaFiscal }
                        comprovante={ this.state.comprovante }
                        analiseContabil={ this.state.analiseContabil }
                        voltar={ this.voltar }
                        confirmar={ this.confirmar }
                        disabled={ this.state.disabled } /> }
            </div>
        );
    }

}

export default withRouter(CadastrarMovimentacao);

